import { type AnimationEventHandler, type RefObject, useCallback, useState } from 'react';
import { ANIMATION_STATES } from './constants';
import { type AnimationState } from './types';

interface UseAnimationStateParams {
    target: RefObject<HTMLElement>;
    isOpen: Boolean;
    onAnimationEnd?: (animationState: AnimationState) => void;
}

export const useAnimationState = ({ target, isOpen, onAnimationEnd: onAnimationEndProp }: UseAnimationStateParams) => {
    const [animationState, setAnimationState] = useState<AnimationState>(ANIMATION_STATES.NONE);

    if (isOpen) {
        if (animationState === ANIMATION_STATES.CLOSE) {
            setAnimationState(ANIMATION_STATES.OPEN);
        }
    } else if (animationState !== ANIMATION_STATES.CLOSE) {
        setAnimationState(ANIMATION_STATES.CLOSE);
    }

    const onAnimationEnd = useCallback<AnimationEventHandler<HTMLElement>>(
        (event) => {
            if (event.target !== target.current) {
                return;
            }

            onAnimationEndProp?.(animationState);
        },
        [animationState, onAnimationEndProp, target]
    );

    return {
        onAnimationEnd,
        animationState,
    };
};
